import pushToDataLayer from "./pushToDataLayer";
import ecommerceDataTemplate from "./ecommerceDataTemplate";

const addToBagEvent = itemData => {
  pushToDataLayer({
    add_to_cart: {
      ecommerce: ecommerceDataTemplate(itemData)
    }
  });
};

export default addToBagEvent;
